module.exports = __webpack_public_path__ + "static/media/influentialPainters.7f47d671.png";